import * as i0 from '@angular/core';
import { EventEmitter, Injectable, Pipe, forwardRef, Component, Input, Output, ViewChildren, HostListener, ViewChild, HostBinding, NgModule } from '@angular/core';
import * as i3 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["dropdownList"];
const _c1 = ["availableOption"];
const _c2 = a0 => ({
  "ngx-disabled": a0
});
const _c3 = a0 => ({
  active: a0
});
const _c4 = (a0, a1) => ({
  item: a0,
  config: a1
});
const _c5 = (a0, a1) => ({
  active: a0,
  disabled: a1
});
const _c6 = a0 => ({
  "up": a0
});
function NgxSelectDropdownComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function NgxSelectDropdownComponent_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.openSelectDropdown());
    });
    i0.ɵɵelementContainer(1, 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const dropdownButton_r3 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, ctx_r1.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.dropdownButtonTemplate || dropdownButton_r3);
  }
}
function NgxSelectDropdownComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function NgxSelectDropdownComponent_div_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.closeSelectDropdown());
    });
    i0.ɵɵelementContainer(1, 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const dropdownButton_r3 = i0.ɵɵreference(11);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, ctx_r1.disabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.dropdownButtonTemplate || dropdownButton_r3);
  }
}
function NgxSelectDropdownComponent_div_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18)(1, "input", 19);
    i0.ɵɵlistener("change", function NgxSelectDropdownComponent_div_3_div_2_Template_input_change_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.changeSearchText($event));
    })("input", function NgxSelectDropdownComponent_div_3_div_2_Template_input_input_1_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.searchTextChanged());
    });
    i0.ɵɵtwoWayListener("ngModelChange", function NgxSelectDropdownComponent_div_3_div_2_Template_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.searchText, $event) || (ctx_r1.searchText = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 20);
    i0.ɵɵelement(3, "span", 21);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("direction", ctx_r1.config.inputDirection);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.searchText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c3, ctx_r1.searchText));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.config.searchPlaceholder, "");
  }
}
function NgxSelectDropdownComponent_div_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "div", 22)(2, "label", 23);
    i0.ɵɵlistener("click", function NgxSelectDropdownComponent_div_3_div_3_Template_label_click_2_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.toggleSelectAll(true, true));
    });
    i0.ɵɵelementStart(3, "input", 24);
    i0.ɵɵtwoWayListener("ngModelChange", function NgxSelectDropdownComponent_div_3_div_3_Template_input_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r1.selectAll, $event) || (ctx_r1.selectAll = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.selectAll);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.config.selectAllLabel);
  }
}
function NgxSelectDropdownComponent_div_3_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵlistener("click", function NgxSelectDropdownComponent_div_3_div_5_Template_div_click_0_listener() {
      const ctx_r7 = i0.ɵɵrestoreView(_r7);
      const selected_r9 = ctx_r7.$implicit;
      const i_r10 = ctx_r7.index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.deselectItem(selected_r9, i_r10));
    })("mousedown", function NgxSelectDropdownComponent_div_3_div_5_Template_div_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.optionMouseDown = true);
    });
    i0.ɵɵelementContainer(1, 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const selected_r9 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const selectedTemplate_r11 = i0.ɵɵreference(9);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.selectedItemTemplate || selectedTemplate_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c4, selected_r9, ctx_r1.config));
  }
}
function NgxSelectDropdownComponent_div_3_hr_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "hr");
  }
}
function NgxSelectDropdownComponent_div_3_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27, 5);
    i0.ɵɵlistener("click", function NgxSelectDropdownComponent_div_3_div_8_Template_div_click_0_listener() {
      const ctx_r12 = i0.ɵɵrestoreView(_r12);
      const item_r14 = ctx_r12.$implicit;
      const i_r15 = ctx_r12.index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectItem(item_r14, i_r15));
    })("mousedown", function NgxSelectDropdownComponent_div_3_div_8_Template_div_mousedown_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.optionMouseDown = true);
    });
    i0.ɵɵelementContainer(2, 26);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const i_r15 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const availableItemTemplate_r16 = i0.ɵɵreference(7);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c5, ctx_r1.focusedItemIndex == i_r15 && !item_r14.disabled, item_r14.disabled));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.optionItemTemplate || availableItemTemplate_r16)("ngTemplateOutletContext", i0.ɵɵpureFunction2(6, _c4, item_r14, ctx_r1.config));
  }
}
function NgxSelectDropdownComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11, 4);
    i0.ɵɵtemplate(2, NgxSelectDropdownComponent_div_3_div_2_Template, 5, 7, "div", 12)(3, NgxSelectDropdownComponent_div_3_div_3_Template, 6, 2, "div", 13);
    i0.ɵɵelementStart(4, "div", 14);
    i0.ɵɵtemplate(5, NgxSelectDropdownComponent_div_3_div_5_Template, 2, 5, "div", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, NgxSelectDropdownComponent_div_3_hr_6_Template, 1, 0, "hr", 13);
    i0.ɵɵelementStart(7, "div", 16);
    i0.ɵɵtemplate(8, NgxSelectDropdownComponent_div_3_div_8_Template, 3, 9, "div", 17);
    i0.ɵɵpipe(9, "filterBy");
    i0.ɵɵpipe(10, "limitTo");
    i0.ɵɵelementContainer(11, 10);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const notFound_r17 = i0.ɵɵreference(5);
    i0.ɵɵstyleProp("max-height", ctx_r1.config.height)("top", ctx_r1.top);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.config.search);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.config.enableSelectAll && ctx_r1.multiple);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.selectedItems);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedItems.length > 0 && ctx_r1.availableItems.length > 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind2(10, 14, i0.ɵɵpipeBind3(9, 10, ctx_r1.availableItems, ctx_r1.searchText, ctx_r1.config.searchOnKey), ctx_r1.config.limitTo));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.notFoundTemplate || notFound_r17);
  }
}
function NgxSelectDropdownComponent_ng_template_4_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.config.noResultsFound);
  }
}
function NgxSelectDropdownComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, NgxSelectDropdownComponent_ng_template_4_div_0_Template, 2, 1, "div", 13);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r1.showNotFound);
  }
}
function NgxSelectDropdownComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r18 = ctx.item;
    const config_r19 = ctx.config;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", config_r19.displayFn ? config_r19.displayFn(item_r18) : item_r18[config_r19.displayKey] || item_r18, " ");
  }
}
function NgxSelectDropdownComponent_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 28);
    i0.ɵɵtext(1, "x");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r20 = ctx.item;
    const config_r21 = ctx.config;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", config_r21.displayFn ? config_r21.displayFn(item_r20) : item_r20[config_r21.displayKey] || item_r20, " ");
  }
}
function NgxSelectDropdownComponent_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 29)(1, "span", 30);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 31);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c2, ctx_r1.disabled))("disabled", ctx_r1.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r1.selectedDisplayText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c6, ctx_r1.toggleDropdown));
  }
}
let SelectDropDownService = /*#__PURE__*/(() => {
  class SelectDropDownService {
    constructor() {
      this.openDropdownInstance = new EventEmitter();
      this.closeDropdownInstance = new EventEmitter();
      this.openInstances = [];
      // constructor
    }
    isOpen(instanceId) {
      return this.openInstances.indexOf(instanceId) > -1;
    }
    /**
     * @summary: Open a specific dropdown instance based on the instance ID.
     * @param instanceId: Instance id of the dropdown that must be opened.
     */
    openDropdown(instanceId) {
      this.openDropdownInstance.emit(instanceId);
    }
    /**
     * @summary: Close a specific dropdown instance based on the instance ID.
     * @param instanceId: Instance id of the dropdown that must be closed.
     */
    closeDropdown(instanceId) {
      this.closeDropdownInstance.emit(instanceId);
    }
  }
  /** @nocollapse */
  /** @nocollapse */SelectDropDownService.ɵfac = function SelectDropDownService_Factory(t) {
    return new (t || SelectDropDownService)();
  };
  SelectDropDownService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SelectDropDownService,
    factory: SelectDropDownService.ɵfac,
    providedIn: "root"
  });
  return SelectDropDownService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * filters an array based on searctext
 */
let FilterByPipe = /*#__PURE__*/(() => {
  class FilterByPipe {
    transform(array, searchText, keyName) {
      if (!array || !searchText || !Array.isArray(array)) {
        return array;
      }
      if (typeof array[0] === 'string') {
        return array.filter(item => item.toLowerCase().indexOf(searchText.trim().toLowerCase()) > -1);
      }
      // filter array, items which match and return true will be
      // kept, false will be filtered out
      if (!keyName) {
        return array.filter(item => {
          for (const key in item) {
            if (typeof item[key] !== 'object' && item[key].toString().toLowerCase().indexOf(searchText.trim().toLowerCase()) > -1) {
              return true;
            }
          }
          return false;
        });
      } else {
        return array.filter(item => {
          if (typeof item[keyName] !== 'object' && item[keyName].toString().toLowerCase().indexOf(searchText.trim().toLowerCase()) > -1) {
            return true;
          }
          return false;
        });
      }
    }
  }
  /** @nocollapse */
  /** @nocollapse */FilterByPipe.ɵfac = function FilterByPipe_Factory(t) {
    return new (t || FilterByPipe)();
  };
  FilterByPipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "filterBy",
    type: FilterByPipe,
    pure: true
  });
  return FilterByPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LimitToPipe = /*#__PURE__*/(() => {
  class LimitToPipe {
    transform(array, itemsCount, startIndex = 0) {
      if (!Array.isArray(array) || itemsCount === 0) {
        return array;
      }
      return array.slice(startIndex, startIndex + itemsCount);
    }
  }
  /** @nocollapse */
  /** @nocollapse */LimitToPipe.ɵfac = function LimitToPipe_Factory(t) {
    return new (t || LimitToPipe)();
  };
  LimitToPipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "limitTo",
    type: LimitToPipe,
    pure: true
  });
  return LimitToPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const config = {
  displayKey: "description",
  height: "auto",
  search: false,
  placeholder: "Select",
  searchPlaceholder: "Search...",
  limitTo: 0,
  customComparator: undefined,
  noResultsFound: "No results found!",
  moreText: "more",
  searchOnKey: null,
  clearOnSelection: false,
  inputDirection: "ltr",
  selectAllLabel: "Select all",
  enableSelectAll: false
};
let NgxSelectDropdownComponent = /*#__PURE__*/(() => {
  class NgxSelectDropdownComponent {
    constructor(cdref, _elementRef, dropdownService) {
      this.cdref = cdref;
      this._elementRef = _elementRef;
      this.dropdownService = dropdownService;
      /**
       * Get the required inputs
       */
      this.options = [];
      /**
       * configuration options
       */
      this.config = config;
      /**
       * Whether multiple selection or single selection allowed
       */
      this.multiple = false;
      /**
       * change event when value changes to provide user to handle things in change event
       */
      this.change = new EventEmitter();
      /**
       * The search text change event emitter emitted when user type in the search input
       */
      this.searchChange = new EventEmitter();
      /**
       * Event emitted when dropdown is open.
       */
      this.open = new EventEmitter();
      /**
       * Event emitted when dropdown is open.
       */
      this.close = new EventEmitter();
      /**
       * Toogle the dropdown list
       */
      this.toggleDropdown = false;
      /**
       * Available items for selection
       */
      this.availableItems = [];
      /**
       * Selected Items
       */
      this.selectedItems = [];
      /**
       * Selection text to be Displayed
       */
      this.selectedDisplayText = "Select";
      /**
       * variable to track if clicked inside or outside of component
       */
      this.clickedInside = false;
      /**
       * variable to track keypress event inside and outsid of component
       */
      this.insideKeyPress = false;
      /**
       * variable to track the focused item whenuser uses arrow keys to select item
       */
      this.focusedItemIndex = null;
      /**
       * element to show not found text when not itmes match the search
       */
      this.showNotFound = false;
      this.onChange = () => {
        // empty
      };
      this.onTouched = () => {
        // empty
      };
      /**
       * Binding to set the tabindex property to set to 0 for accessibilty
       */
      this.tabindex = 0;
      this.multiple = false;
      this.selectAll = false;
    }
    get value() {
      return this._value;
    }
    set value(val) {
      this._value = val;
      this.onChange(val);
      this.onTouched();
    }
    /**
     * click listener for host inside this component i.e
     * if many instances are there, this detects if clicked inside
     * this instance
     */
    clickInsideComponent() {
      this.clickedInside = true;
    }
    /**
     * View reference for the dorpdown list
     */
    set dropDownElement(ref) {
      if (ref) {
        // initially setter gets called with undefined
        this.dropdownList = ref;
      }
    }
    /**
     * Event listener for the blur event to hide the dropdown
     */
    blur($event) {
      if (!this.insideKeyPress && !this.optionMouseDown && $event instanceof KeyboardEvent) {
        this.toggleDropdown = false;
        this.openStateChange();
      }
    }
    /**
     * Event listener for the focus event to show the dropdown when using tab key
     */
    focus() {
      /* istanbul ignore else */
      if (!this.disabled) {
        this.toggleDropdown = true;
        this.openStateChange();
      }
    }
    /**
     * click handler on documnent to hide the open dropdown if clicked outside
     */
    clickOutsideComponent() {
      /* istanbul ignore else */
      if (!this.clickedInside) {
        this.toggleDropdown = false;
        this.openStateChange();
        this.resetArrowKeyActiveElement();
        // clear searh on close
        this.searchText = null;
        this.close.emit();
      }
      this.clickedInside = false;
    }
    /**
     * click handler on documnent to hide the open dropdown if clicked outside
     */
    KeyPressOutsideComponent() {
      /* istanbul ignore else */
      if (!this.insideKeyPress) {
        this.toggleDropdown = false;
        this.openStateChange();
        this.resetArrowKeyActiveElement();
      }
      this.insideKeyPress = false;
    }
    /**
     * Event handler for key up and down event and enter press for selecting element
     */
    handleKeyboardEvent($event) {
      this.insideKeyPress = true;
      /* istanbul ignore else */
      if ($event.keyCode === 27 || this.disabled) {
        this.toggleDropdown = false;
        this.openStateChange();
        this.insideKeyPress = false;
        return;
      }
      const avaOpts = this.availableOptions.toArray();
      /* istanbul ignore else */
      if ($event.keyCode !== 9 && avaOpts.length === 0 && !this.toggleDropdown) {
        this.toggleDropdown = true;
        this.openStateChange();
      }
      // Arrow Down
      /* istanbul ignore else */
      if ($event.keyCode === 40 && avaOpts.length > 0) {
        this.onArrowKeyDown();
        /* istanbul ignore else */
        if (this.focusedItemIndex >= avaOpts.length) {
          this.focusedItemIndex = 0;
        }
        avaOpts[this.focusedItemIndex].nativeElement.focus();
        $event.preventDefault();
      }
      // Arrow Up
      /* istanbul ignore else */
      if ($event.keyCode === 38 && avaOpts.length) {
        this.onArrowKeyUp();
        /* istanbul ignore else */
        if (this.focusedItemIndex >= avaOpts.length) {
          this.focusedItemIndex = avaOpts.length - 1;
        }
        avaOpts[this.focusedItemIndex].nativeElement.focus();
        $event.preventDefault();
      }
      // Enter
      /* istanbul ignore else */
      if ($event.keyCode === 13 && this.focusedItemIndex !== null) {
        const filteredItems = new FilterByPipe().transform(this.availableItems, this.searchText, this.config.searchOnKey);
        this.selectItem(filteredItems[this.focusedItemIndex], this.availableItems.indexOf(filteredItems[this.focusedItemIndex]));
        return false;
      }
    }
    /**
     * Component onInit
     */
    ngOnInit() {
      /* istanbul ignore else */
      if (typeof this.options !== "undefined" && typeof this.config !== "undefined" && Array.isArray(this.options)) {
        this.availableItems = [...this.options.sort(this.config.customComparator)];
        this.initDropdownValuesAndOptions();
      }
      this.serviceSubscriptions();
    }
    isVisible() {
      if (!this.dropdownList) {
        return {
          visible: false,
          element: null
        };
      }
      const el = this.dropdownList.nativeElement;
      if (!el) {
        return {
          visible: false,
          element: el
        };
      }
      const rect = el.getBoundingClientRect();
      const topShown = rect.top >= 0;
      const bottomShown = rect.bottom <= window.innerHeight;
      return {
        visible: topShown && bottomShown,
        element: el
      };
    }
    serviceSubscriptions() {
      this.dropdownService.openDropdownInstance.subscribe(instanceId => {
        if (this.instanceId === instanceId) {
          this.toggleDropdown = true;
          this.openStateChange();
          this.resetArrowKeyActiveElement();
        }
      });
      this.dropdownService.closeDropdownInstance.subscribe(instanceId => {
        if (this.instanceId === instanceId) {
          this.toggleDropdown = false;
          this.openStateChange();
          this.resetArrowKeyActiveElement();
        }
      });
    }
    /**
     * after view init to subscribe to available option changes
     */
    ngAfterViewInit() {
      this.availableOptions.changes.subscribe(this.setNotFoundState.bind(this));
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    writeValue(value, internal) {
      if (value) {
        if (Array.isArray(value)) {
          if (this.multiple) {
            this.value = value;
          } else if (value.length > 0) {
            this.value = value[0];
          }
        } else {
          this.value = value;
        }
        /* istanbul ignore else */
        if (this.selectedItems.length === 0) {
          if (Array.isArray(value)) {
            this.selectedItems = value;
          } else {
            this.selectedItems.push(value);
          }
          this.initDropdownValuesAndOptions();
        }
      } else {
        this.value = [];
        /* istanbul ignore else */
        if (!internal) {
          this.reset();
        }
      }
      /* istanbul ignore else */
      if (!internal) {
        this.reset();
      }
    }
    reset() {
      if (!this.config) {
        return;
      }
      this.selectedItems = [];
      this.availableItems = [...this.options.sort(this.config.customComparator)];
      this.initDropdownValuesAndOptions();
    }
    /**
     * function sets whether to show items not found text or not
     */
    setNotFoundState() {
      if (this.availableOptions.length === 0 && this.selectedItems.length !== this.options.length) {
        this.showNotFound = true;
      } else {
        this.showNotFound = false;
      }
      this.cdref.detectChanges();
    }
    /**
     * Component onchage i.e when any of the input properties change
     */
    ngOnChanges(changes) {
      if (!this.config) {
        return;
      }
      this.selectedItems = [];
      // this.searchText = null;
      this.options = this.options || [];
      /* istanbul ignore else */
      if (changes.options) {
        this.availableItems = [...this.options.sort(this.config.customComparator)];
      }
      /* istanbul ignore else */
      if (changes.value) {
        /* istanbul ignore else */
        if (JSON.stringify(changes.value.currentValue) === JSON.stringify([]) || changes.value.currentValue === "" || changes.value.currentValue === null) {
          this.availableItems = [...this.options.sort(this.config.customComparator)];
        }
      }
      this.initDropdownValuesAndOptions();
    }
    /**
     * Deselct a selected items
     * @param item:  item to be deselected
     * @param index:  index of the item
     */
    deselectItem(item, index) {
      this.selectedItems.forEach((element, i) => {
        /* istanbul ignore else */
        if (item === element) {
          this.selectedItems.splice(i, 1);
        }
      });
      let sortedItems = [...this.availableItems];
      /* istanbul ignore else */
      if (!this.availableItems.includes(item)) {
        this.availableItems.push(item);
        sortedItems = this.availableItems.sort(this.config.customComparator);
      }
      this.selectedItems = [...this.selectedItems];
      this.availableItems = [...sortedItems];
      /* istanbul ignore else */
      if (!Array.isArray(this.value)) {
        this.value = [];
      }
      if (!this.areAllSelected()) {
        this.selectAll = false;
      }
      this.valueChanged();
      this.resetArrowKeyActiveElement();
    }
    /**
     * Select an item
     * @param item:  item to be selected
     * @param index:  index of the item
     */
    selectItem(item, index) {
      /* istanbul ignore else */
      if (!this.multiple) {
        /* istanbul ignore else */
        if (this.selectedItems.length > 0) {
          this.availableItems.push(this.selectedItems[0]);
        }
        this.selectedItems = [];
        this.toggleDropdown = false;
      }
      this.availableItems.forEach((element, i) => {
        /* istanbul ignore else */
        if (item === element) {
          this.selectedItems.push(item);
          this.availableItems.splice(i, 1);
        }
      });
      /* istanbul ignore else */
      if (this.config.clearOnSelection) {
        this.searchText = null;
      }
      this.selectedItems = [...this.selectedItems];
      this.availableItems = [...this.availableItems];
      this.selectedItems.sort(this.config.customComparator);
      this.availableItems.sort(this.config.customComparator);
      // this.searchText = null;
      /* istanbul ignore else */
      if (this.areAllSelected()) {
        this.selectAll = true;
      }
      this.valueChanged();
      this.resetArrowKeyActiveElement();
    }
    /**
     * When selected items changes trigger the chaange back to parent
     */
    valueChanged() {
      this.writeValue(this.selectedItems, true);
      // this.valueChange.emit(this.value);
      this.change.emit({
        value: this.value
      });
      this.setSelectedDisplayText();
    }
    /**
     * Toggle the dropdownlist on/off
     */
    openSelectDropdown() {
      this.toggleDropdown = true;
      this.top = "30px";
      this.openStateChange();
      this.resetArrowKeyActiveElement();
      setTimeout(() => {
        const {
          visible,
          element
        } = this.isVisible();
        if (element) {
          this.top = visible ? "30px" : `-${element.getBoundingClientRect().height}px`;
        }
      }, 3);
    }
    closeSelectDropdown() {
      this.toggleDropdown = false;
      this.openStateChange();
      this.resetArrowKeyActiveElement();
    }
    openStateChange() {
      if (this.toggleDropdown) {
        this.dropdownService.openInstances.push(this.instanceId);
        this.open.emit();
      } else {
        this.searchText = null;
        this.optionMouseDown = false;
        this.close.emit();
        this.dropdownService.openInstances.splice(this.dropdownService.openInstances.indexOf(this.instanceId), 1);
      }
    }
    /**
     * The change handler for search text
     */
    searchTextChanged() {
      this.searchChange.emit(this.searchText);
    }
    changeSearchText($event) {
      $event.stopPropagation();
    }
    /**
     * initialize the config and other properties
     */
    initDropdownValuesAndOptions() {
      /* istanbul ignore else */
      if (typeof this.config === "undefined" || Object.keys(this.config).length === 0) {
        this.config = {
          ...config
        };
      }
      for (const key of Object.keys(config)) {
        this.config[key] = this.config[key] ? this.config[key] : config[key];
      }
      this.config = {
        ...this.config
      };
      // Adding placeholder in config as default param
      this.selectedDisplayText = this.config["placeholder"];
      /* istanbul ignore else */
      if (this.value !== "" && typeof this.value !== "undefined") {
        if (Array.isArray(this.value)) {
          this.selectedItems = this.value;
        } else if (this.value !== "" && this.value !== null) {
          this.selectedItems[0] = this.value;
        } else {
          this.selectedItems = [];
          this.value = [];
        }
        this.selectedItems.forEach(item => {
          const ind = this.availableItems.findIndex(aItem => JSON.stringify(item) === JSON.stringify(aItem));
          if (ind !== -1) {
            this.availableItems.splice(ind, 1);
          }
        });
      }
      this.setSelectedDisplayText();
    }
    /**
     * set the text to be displayed
     */
    setSelectedDisplayText() {
      let text = this.selectedItems[0];
      /* istanbul ignore else */
      if (typeof this.selectedItems[0] === "object") {
        text = this.config.displayFn ? this.config.displayFn(this.selectedItems[0]) : this.selectedItems[0][this.config.displayKey];
      }
      if (this.multiple && this.selectedItems.length > 0) {
        this.selectedDisplayText = this.selectedItems.length === 1 ? text : text + ` + ${this.selectedItems.length - 1} ${this.config.moreText}`;
      } else {
        this.selectedDisplayText = this.selectedItems.length === 0 ? this.config.placeholder : text;
      }
    }
    /**
     * Event handler for arrow key up event thats focuses on a item
     */
    onArrowKeyUp() {
      /* istanbul ignore else */
      if (this.focusedItemIndex === 0) {
        this.focusedItemIndex = this.availableItems.length - 1;
        return;
      }
      /* istanbul ignore else */
      if (this.onArrowKey()) {
        this.focusedItemIndex--;
      }
    }
    /**
     * Event handler for arrow key down event thats focuses on a item
     */
    onArrowKeyDown() {
      /* istanbul ignore else */
      if (this.focusedItemIndex === this.availableItems.length - 1) {
        this.focusedItemIndex = 0;
        return;
      }
      /* istanbul ignore else */
      if (this.onArrowKey()) {
        this.focusedItemIndex++;
      }
    }
    onArrowKey() {
      /* istanbul ignore else */
      if (this.focusedItemIndex === null) {
        this.focusedItemIndex = 0;
        return false;
      }
      return true;
    }
    /**
     * will reset the element that is marked active using arrow keys
     */
    resetArrowKeyActiveElement() {
      this.focusedItemIndex = null;
    }
    /**
     * Toggle the select all option
     */
    toggleSelectAll(close, emitChange) {
      this.selectAll = !this.selectAll;
      if (this.selectAll) {
        this.selectedItems = [...this.selectedItems, ...this.availableItems];
        this.availableItems = [];
      } else {
        this.availableItems = [...this.selectedItems, ...this.availableItems];
        this.selectedItems = [];
      }
      this.selectedItems.sort(this.config.customComparator);
      this.availableItems.sort(this.config.customComparator);
      this.valueChanged();
      this.closeSelectDropdown();
      this.openStateChange();
      this.resetArrowKeyActiveElement();
    }
    /**
     * Check if all options selected
     */
    areAllSelected() {
      return this.selectedItems.length === this.options.length;
    }
  }
  /** @nocollapse */
  /** @nocollapse */NgxSelectDropdownComponent.ɵfac = function NgxSelectDropdownComponent_Factory(t) {
    return new (t || NgxSelectDropdownComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(SelectDropDownService));
  };
  NgxSelectDropdownComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NgxSelectDropdownComponent,
    selectors: [["ngx-select-dropdown"]],
    viewQuery: function NgxSelectDropdownComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropDownElement = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.availableOptions = _t);
      }
    },
    hostVars: 1,
    hostBindings: function NgxSelectDropdownComponent_HostBindings(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵlistener("click", function NgxSelectDropdownComponent_click_HostBindingHandler() {
          return ctx.clickInsideComponent();
        })("blur", function NgxSelectDropdownComponent_blur_HostBindingHandler() {
          return ctx.blur();
        })("focus", function NgxSelectDropdownComponent_focus_HostBindingHandler() {
          return ctx.focus();
        })("click", function NgxSelectDropdownComponent_click_HostBindingHandler() {
          return ctx.clickOutsideComponent();
        }, false, i0.ɵɵresolveDocument)("keydown", function NgxSelectDropdownComponent_keydown_HostBindingHandler() {
          return ctx.KeyPressOutsideComponent();
        }, false, i0.ɵɵresolveDocument)("keydown", function NgxSelectDropdownComponent_keydown_HostBindingHandler($event) {
          return ctx.handleKeyboardEvent($event);
        });
      }
      if (rf & 2) {
        i0.ɵɵattribute("tabindex", ctx.tabindex);
      }
    },
    inputs: {
      _value: "_value",
      options: "options",
      config: "config",
      multiple: "multiple",
      disabled: "disabled",
      instanceId: "instanceId",
      selectedItemTemplate: "selectedItemTemplate",
      optionItemTemplate: "optionItemTemplate",
      notFoundTemplate: "notFoundTemplate",
      dropdownButtonTemplate: "dropdownButtonTemplate"
    },
    outputs: {
      change: "change",
      searchChange: "searchChange",
      open: "open",
      close: "close"
    },
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NgxSelectDropdownComponent),
      multi: true
    }]), i0.ɵɵNgOnChangesFeature],
    decls: 12,
    vars: 3,
    consts: [["notFound", ""], ["availableItemTemplate", ""], ["selectedTemplate", ""], ["dropdownButton", ""], ["dropdownList", ""], ["availableOption", ""], [1, "ngx-dropdown-container"], [3, "ngClass", "click", 4, "ngIf"], ["class", "ngx-dropdown-list-container", 3, "maxHeight", "top", 4, "ngIf"], [3, "click", "ngClass"], [3, "ngTemplateOutlet"], [1, "ngx-dropdown-list-container"], ["class", "search-container", 4, "ngIf"], [4, "ngIf"], [1, "selected-items"], ["class", "selected-item", "tabindex", "-1", 3, "click", "mousedown", 4, "ngFor", "ngForOf"], [1, "available-items"], ["class", "available-item", "tabindex", "-1", 3, "ngClass", "click", "mousedown", 4, "ngFor", "ngForOf"], [1, "search-container"], ["name", "search-text", "tabindex", "-1", "autocomplete", "off", 3, "change", "input", "ngModelChange", "ngModel"], [3, "ngClass"], [1, "nsdicon-search"], [1, "select-options"], [3, "click"], ["type", "checkbox", 1, "filled-in", 3, "ngModelChange", "ngModel"], ["tabindex", "-1", 1, "selected-item", 3, "click", "mousedown"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], ["tabindex", "-1", 1, "available-item", 3, "click", "mousedown", "ngClass"], [1, "nsdicon-close"], ["type", "button", "tabindex", "-1", 1, "ngx-dropdown-button", 3, "ngClass", "disabled"], [1, "display-text"], [1, "nsdicon-angle-down", 3, "ngClass"]],
    template: function NgxSelectDropdownComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 6);
        i0.ɵɵtemplate(1, NgxSelectDropdownComponent_div_1_Template, 2, 4, "div", 7)(2, NgxSelectDropdownComponent_div_2_Template, 2, 4, "div", 7)(3, NgxSelectDropdownComponent_div_3_Template, 12, 17, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, NgxSelectDropdownComponent_ng_template_4_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(6, NgxSelectDropdownComponent_ng_template_6_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(8, NgxSelectDropdownComponent_ng_template_8_Template, 4, 1, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(10, NgxSelectDropdownComponent_ng_template_10_Template, 4, 8, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.toggleDropdown);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.toggleDropdown);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.toggleDropdown);
      }
    },
    dependencies: [i2.NgClass, i2.NgForOf, i2.NgIf, i2.NgTemplateOutlet, i3.DefaultValueAccessor, i3.CheckboxControlValueAccessor, i3.NgControlStatus, i3.NgModel, FilterByPipe, LimitToPipe],
    styles: [".ngx-dropdown-container[_ngcontent-%COMP%]{width:100%;position:relative}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-button[_ngcontent-%COMP%]{display:inline-block;margin-bottom:0;font-weight:400;line-height:1.42857143;vertical-align:middle;touch-action:manipulation;cursor:pointer;-webkit-user-select:none;user-select:none;border:1px solid #ccc;border-radius:4px;color:#333;background-color:#fff;white-space:nowrap;overflow-x:hidden;text-overflow:ellipsis;text-align:left}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-button[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{display:inline;vertical-align:middle}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-button[_ngcontent-%COMP%]   .nsdicon-angle-down[_ngcontent-%COMP%]{right:5px;position:relative;float:right;transition:transform .2s ease}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-button[_ngcontent-%COMP%]   .nsdicon-angle-down[_ngcontent-%COMP%]:before{border-style:solid;border-width:.1em .1em 0 0;content:\"\";display:inline-block;height:10px;position:relative;vertical-align:text-top;width:10px;top:0;transform:rotate(135deg)}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-button[_ngcontent-%COMP%]   .nsdicon-angle-down.up[_ngcontent-%COMP%]{transform:rotate(180deg);transition:transform .2s ease}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-button[_ngcontent-%COMP%]{width:100%;min-height:30px;padding:5px 10px;background-color:#fff}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-button[_ngcontent-%COMP%]   .display-text[_ngcontent-%COMP%]{display:inline-block;width:calc(100% - 20px)}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]{box-sizing:border-box;border:1px solid rgba(0,0,0,.15);border-radius:4px;padding-left:10px;padding-right:10px;z-index:999999999;width:100%;background-clip:padding-box;background:white;position:absolute;box-shadow:5px 5px 5px #00000036;overflow-y:auto}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .select-options[_ngcontent-%COMP%]{padding-top:10px}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .select-options[_ngcontent-%COMP%]   .filled-in[_ngcontent-%COMP%]:checked + span[_ngcontent-%COMP%]:not(.lever):after, .ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .select-options[_ngcontent-%COMP%]   .filled-in[_ngcontent-%COMP%]:not(:checked) + span[_ngcontent-%COMP%]:not(.lever):after{height:15px;width:15px}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .select-options[_ngcontent-%COMP%]   .filled-in[_ngcontent-%COMP%]:checked + span[_ngcontent-%COMP%]:not(.lever):after{border-color:#337ab7;background-color:#337ab7}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .select-options[_ngcontent-%COMP%]   .filled-in[_ngcontent-%COMP%]:checked + span[_ngcontent-%COMP%]:not(.lever):before{top:-2px;left:1px;width:5px;height:11px}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .select-options[_ngcontent-%COMP%]   [type=checkbox][_ngcontent-%COMP%] + span[_ngcontent-%COMP%]:not(.lever){line-height:15px;height:15px;padding-left:25px}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]{position:relative;padding-top:10px;margin-top:5px}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{background-color:transparent;border:none;border-bottom:1px solid #9e9e9e;border-radius:0;outline:none;height:2rem;width:100%;font-size:13px;margin:0;padding:0;box-shadow:none;box-sizing:content-box;transition:all .3s}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus{border-bottom:1px solid #26a69a}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]:focus + label[_ngcontent-%COMP%]{transform:translateY(-2px) scale(.8);transform-origin:0 0}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{color:#9e9e9e;position:absolute;top:0;left:0;height:100%;font-size:1rem;cursor:text;transition:transform .2s ease-out;transform-origin:0% 100%;text-align:initial;transform:translateY(12px);pointer-events:none}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .search-container[_ngcontent-%COMP%]   label.active[_ngcontent-%COMP%]{transform:translateY(-2px) scale(.8);transform-origin:0 0}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .available-items[_ngcontent-%COMP%], .ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .selected-items[_ngcontent-%COMP%]{margin-top:1rem;margin-bottom:1rem;list-style-type:none;padding-left:0}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .available-items.selected-items[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%], .ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .selected-items.selected-items[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%]{background-color:#337ab7;color:#fff;margin-bottom:2px}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .available-items.selected-items[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%]   .nsdicon-close[_ngcontent-%COMP%], .ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .selected-items.selected-items[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%]   .nsdicon-close[_ngcontent-%COMP%]{font-weight:700;font-size:large}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .available-items.available-items[_ngcontent-%COMP%]   .available-item.active[_ngcontent-%COMP%], .ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .selected-items.available-items[_ngcontent-%COMP%]   .available-item.active[_ngcontent-%COMP%]{background-color:#337ab7;color:#fff}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .available-items[_ngcontent-%COMP%]   .available-item[_ngcontent-%COMP%], .ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .available-items[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%], .ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .selected-items[_ngcontent-%COMP%]   .available-item[_ngcontent-%COMP%], .ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-dropdown-list-container[_ngcontent-%COMP%]   .selected-items[_ngcontent-%COMP%]   .selected-item[_ngcontent-%COMP%]{font-size:inherit;cursor:pointer;display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:normal}.ngx-dropdown-container[_ngcontent-%COMP%]   .ngx-disabled[_ngcontent-%COMP%]{pointer-events:none;background-color:#e9ecef;opacity:1;cursor:no-drop}"]
  });
  return NgxSelectDropdownComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SelectDropDownModule = /*#__PURE__*/(() => {
  class SelectDropDownModule {}
  /** @nocollapse */
  /** @nocollapse */
  /** @nocollapse */SelectDropDownModule.ɵfac = function SelectDropDownModule_Factory(t) {
    return new (t || SelectDropDownModule)();
  };
  SelectDropDownModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: SelectDropDownModule
  });
  SelectDropDownModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, FormsModule]
  });
  return SelectDropDownModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-select-dropdown
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FilterByPipe, LimitToPipe, NgxSelectDropdownComponent, SelectDropDownModule, SelectDropDownService };
